export default "__VITE_ASSET__qkq8KA0j__"